import { useSelector } from 'react-redux';
import { PROMO_TARIFFS } from 'reactApp/appHelpers/configHelpers';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { EProductPeriod } from 'reactApp/modules/products/products.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { RootState } from 'reactApp/store';

import { EShowTariffType, TariffInfo } from '../UploadBigFileDialog.types';

export const useTariff = (fileSizeBytes: number): TariffInfo => {
    const { isFull: isOverQuota } = useSelector(UserSelectors.getCloudSpace);

    const trial = useSelector((state: RootState) => ProductsSelectors.getProductById(state, PROMO_TARIFFS?.default128GbTrial));
    const { product } = useSelector((state: RootState) =>
        ProductsSelectors.getProductAndTariffByQuota(state, fileSizeBytes, EProductPeriod.year, false)
    );
    const isPaidUser = useSelector(UserSelectors.isPaidUser);

    // если в квоту триала помещаются загружаемые файлы, пользователей не платник,
    // не в оверквоте и ему доступен триальный тариф, то показываем его
    const isTrialUser = !isPaidUser && !isOverQuota && Boolean(trial) && fileSizeBytes < trial.space.original;

    return {
        trial,
        usualProduct: product,
        showTariffType: isTrialUser ? EShowTariffType.TRIAL : EShowTariffType.USUAL_TARIFF,
    };
};
